// Contenu éditorial par morphologie : noms, descriptions, conseils.
// Réutilisés par l'écran de résultat (chat + formulaire).

import type { Morphology } from './types';

export const MORPHO_NAMES: Record<Morphology, string> = {
  X: 'Sablier',
  '8': 'Double sablier',
  A: 'Triangle',
  V: 'Triangle inversé',
  H: 'Rectangle',
  O: 'Ovale',
};

export const MORPHO_DESCS: Record<Morphology, string> = {
  X: 'Épaules et hanches équilibrées, taille très marquée. Silhouette la plus polyvalente.',
  '8': 'Comme le sablier, avec un volume prononcé en haut et en bas. Courbes généreuses.',
  A: 'Hanches nettement plus larges que les épaules. Silhouette féminine et galbée.',
  V: 'Épaules nettement plus larges que les hanches. Silhouette athlétique.',
  H: 'Épaules et hanches similaires, taille peu marquée. Silhouette droite et harmonieuse.',
  O: 'Volume centré sur le ventre et le buste. Silhouette ronde et douce.',
};

export const MORPHO_TIPS: Record<Morphology, string[]> = {
  X: [
    'Le triangle et le balconnet mettent en valeur ta taille naturelle',
    'Les bas classiques ou cheeky équilibrent harmonieusement',
    'Tu peux oser tous les coloris — unis comme dégradés',
    'Les maillots une pièce dos nu sont particulièrement flatteurs',
  ],
  '8': [
    'Les hauts avec armatures apportent le maintien nécessaire',
    'Les bas taille haute ou classiques affinent la taille',
    'Le maillot une pièce gainant est très flatteur',
    'Choisis des matières structurées pour un soutien optimal',
  ],
  A: [
    'Les hauts avec détails attirent le regard vers le haut',
    'Les bas unis et classiques équilibrent ta silhouette',
    'Le dos nu met en valeur ton haut du corps',
    'Évite les bas très échancrés qui accentuent les hanches',
  ],
  V: [
    'La brassière équilibre tes épaules sans les accentuer',
    'Les bas cheeky ou tanga apportent du volume en bas',
    'Évite les hauts avec bretelles larges ou épaules structurées',
    'Les dégradés créent un joli équilibre visuel',
  ],
  H: [
    "Le triangle crée l'illusion d'une taille plus fine",
    'Les fronces et détails sur les hauts créent du volume',
    'Les bas cheeky apportent de la définition',
    'Le maillot une pièce dos nu allonge et structure',
  ],
  O: [
    'La brassière structure et soutient le buste',
    'Les bas classiques avec bonne couvrance sont idéaux',
    'Les coloris unis allongent visuellement la silhouette',
    'Évite les coupes qui accentuent le ventre',
  ],
};
